import { rpc } from '@/rpc';
import { map } from 'nanostores';
import * as SQL from './sql';
import type { SqlValue } from '@sqlite.org/sqlite-wasm';

export interface Table {
  name: string;
  sql: string;
  info: {
    cid: number;
    dflt_value: SqlValue;
    name: string;
    notnull: number;
    pk: number;
    type: string;
  }[];
}

export interface DB {
  name: string;
  tables: Table[];
}

export const $db = map<DB>({
  name: 'chinook_sqlite.sqlite',
  tables: [],
});

export async function reloadTables() {
  const tables: Table[] = (await rpc.exec(SQL.GetTables())) as any[];

  for (const table of tables) {
    const info: any[] = await rpc.exec(SQL.GetTableInfo(table.name));
    table.info = info;
  }
  $db.setKey('tables', tables);
}
